import { Column, TagTextAlert, TextWithLink } from "@bridgesplit/ui";
import { TokenRestrictionsConfig } from "app/hooks";

export function TokenRestrictionAlerts({
    tokenRestrictionConfig
}: {
    tokenRestrictionConfig: TokenRestrictionsConfig | undefined;
}) {
    if (!tokenRestrictionConfig || tokenRestrictionConfig.restrictions?.length === 0) return null;
    const isBlocking = tokenRestrictionConfig.isBlocking;

    return (
        <Column spacing={0.5}>
            {tokenRestrictionConfig.restrictions?.map((restriction, index) => (
                <TagTextAlert
                    key={`${restriction.restrictionCode}-${index}`}
                    color={isBlocking ? "warning" : "secondary"}
                    textSx={{ display: "inline-block" }}
                    icon={isBlocking ? "warning" : "tooltip"}
                >
                    <TextWithLink text={restriction.formattedMessage} link={restriction.link} isError={isBlocking} />
                </TagTextAlert>
            ))}
        </Column>
    );
}
